import React from "react"
import styles from "./CuisineGenre.module.css"
import { adaptCuisineData } from "./cuisineAdapter"
import { FormTitle } from "../../../Common/FormTitle"
import { CategorySelector } from "../../../Common/Pulldown/CategorySelector"

export const CuisineGenre = () => {
    const cuisineData = adaptCuisineData()

    return (
        <div className={styles.wrapper}>
            <div className={styles.scrollControll}>
                <div className={styles.selectionWrapper}>
                    <div className={styles.monthbox}>
                        <FormTitle
                            formTitleText="料理ジャンルはなんですか？"
                            dataViewLabel="EF_料理ジャンル_pv"
                            dataClickLabel="EF_料理ジャンル_戻る"
                        />
                    </div>
                    <CategorySelector
                        categoryData={cuisineData}
                        formKey={["userResumesAttributes", "genreId"]}
                        displayFormKey={"genre"}
                        idField="genreId"
                        searchPlaceholder="料理ジャンルを検索する"
                        clickLabelPrefix="EF_料理ジャンル"
                    />
                </div>
            </div>
        </div>
    )
}
